import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui/box';
import { isWeb } from 'utils/environment';

// React Native Web supports viewport units, although React Native's DimensionValue omits them.
const WEB_VIEWPORT_HEIGHT = ('100vh' as unknown) as number;

const LoadingContainer = ({ children, style, ...props }: React.PropsWithChildren<BoxProps>) =>
  React.createElement(
    Box,
    { ...props, style: [styles.container, isWeb && styles.webContainer, style] },
    children
  );

export default LoadingContainer;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
  webContainer: {
    height: WEB_VIEWPORT_HEIGHT,
  },
});
